import React from 'react';
import { View, FlatList, StyleSheet, StatusBar, ScrollView } from 'react-native';
import { useSelector } from 'react-redux';
import { DNABox, DNAButton, DNAText, luxColors, useWindowSize } from '@alucio/lux-ui';
const styles = StyleSheet.create({
    closeContainer: {
        flex: 1,
        alignSelf: 'center',
        minWidth: 40,
        marginRight: '4vw',
    },
    container: {
        flex: 1,
        flexDirection: 'column',
        marginTop: StatusBar.currentHeight || 0,
        backgroundColor: 'white',
        width: '100vw',
    },
    header: {
        width: '100vw',
        flexDirection: 'row',
        minWidth: 216,
        height: 48,
        borderWidth: 1,
        borderTopColor: luxColors.headerTopColor.primary,
        borderBottomColor: luxColors.headerTopColor.primary,
        borderLeftColor: luxColors.menuBackground.primary,
        borderRightColor: luxColors.menuBackground.primary,
    },
    item: {
        backgroundColor: luxColors.menuBackground.primary,
        padding: 6,
        borderWidth: 1,
        borderTopColor: luxColors.menuBackground.primary,
        borderBottomColor: luxColors.border.primary,
        borderLeftColor: luxColors.menuBackground.primary,
        borderRightColor: luxColors.menuBackground.primary,
        marginLeft: 10,
    },
    participants: {
        flex: 9,
        marginLeft: 34,
        alignSelf: 'center',
        textAlign: 'center',
    },
    name: {
        fontSize: 19,
        lineHeight: 24,
    },
});
const Item = ({ name, id }) => (React.createElement(View, { style: styles.item },
    React.createElement(DNAText, { style: styles.name, numberOfLines: 1 }, `${name} ${id === 'host' ? ' (Host)' : ''}`)));
const HeaderComponent = (props) => {
    return (React.createElement(View, { style: styles.header },
        React.createElement(DNAText, { h4: true, style: styles.participants },
            "Participants (",
            `${props.remoteParticipants.filter((e) => e.attendeeId !== 'recorder').length + 1}`,
            ") "),
        React.createElement(DNAButton, { style: styles.closeContainer, appearance: "ghost", status: "primary", context: "minimum", size: "large", onPress: props.onClose }, "Close")));
};
const DNAListParticipants = (props) => {
    const remoteParticipants = useSelector((state) => state.virtualRoom.remoteParticpants);
    const localParticipant = useSelector((state) => state.virtualRoom.localParticipant);
    const size = useWindowSize();
    const data = remoteParticipants
        .filter((e) => e.attendeeId !== 'recorder')
        .map((participant) => ({ id: participant.attendeeId, name: participant.name }));
    data.unshift({ id: localParticipant.attendeeId, name: `${localParticipant.name} (You)` });
    const renderItem = ({ item }) => (React.createElement(Item, { name: item.name, id: item.id }));
    return (React.createElement(DNABox, { style: [styles.container, { height: size.height }] },
        React.createElement(HeaderComponent, { onClose: props.onClose, remoteParticipants: remoteParticipants }),
        React.createElement(ScrollView, null,
            React.createElement(FlatList, { data: data.sort((a, b) => a.name.localeCompare(b.name)), renderItem: renderItem, keyExtractor: item => item.id }))));
};
export default DNAListParticipants;
//# sourceMappingURL=DNAListParticipants.js.map